import { WorkshopRepository } from '@/core/workshop/domain/WorkshopRepository.ts'
import { Workshop } from '@/core/workshop/domain/Workshop.ts'

type GetWorkshopsUseCaseDependencies = { workshopRepository: WorkshopRepository }

export class GetWorkshopsUseCase {
  private readonly workshopRepository: WorkshopRepository
  constructor({ workshopRepository }: GetWorkshopsUseCaseDependencies) {
    this.workshopRepository = workshopRepository
  }

  execute = (hostId: string): Promise<Workshop[]> => {
    return this.workshopRepository.getWorkshops(hostId)
  }
}
